import CustomizedTooltipContainer from './CustomizedTooltipContainer';

export default CustomizedTooltipContainer;
